import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { WeekTimeRecord, WeekTimeRecordsScope } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  isDirty: boolean;
  timeRecords: WeekTimeRecord[];
  retrieveWeekTimeRecords(
    request: Boundaries["retrieveWeekTimeRecords"]["request"],
  ): void;
}

function useRetrieveWeekTimeRecords(
  scope: WeekTimeRecordsScope,
  startDate: string,
  endDate: string,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveWeekTimeRecordsRequestPending(
        scope,
        startDate,
        endDate,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveWeekTimeRecordsRequestSuccess(
        scope,
        startDate,
        endDate,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveWeekTimeRecordsRequestFailure(
        scope,
        startDate,
        endDate,
      ),
    ),
    isDirty: useSelector(() =>
      selector.areWeekTimeRecordsDirty(scope, startDate, endDate),
    ),
    timeRecords: useSelector(() =>
      selector.getWeekTimeRecords(scope, startDate, endDate),
    ),
    retrieveWeekTimeRecords: core.retrieveWeekTimeRecords,
  };
}

export { useRetrieveWeekTimeRecords };
